export const DataCellDefaultTable = ({ 
    children, 
    left, 
    sticky, 
    width, 
    selected,
    className = "",
    contentClassName = "",
    disableTruncate = false,
    editable = false,
}) => {
    const bg = selected ? "bg-gray-100" : "bg-white";
    return (
        <td
            className={`box-border border-b border-gray-100 px-2 py-1.5 align-middle text-xs text-gray-800 ${bg} ${className} ${
                sticky ? "sticky z-10 shadow-[1px_0_0_0_#e5e7eb]" : ""
            }`}
            style={{
                width,
                minWidth: width,
                maxWidth: width,
                left: sticky ? left : undefined,
                boxSizing: "border-box",
                background: editable ? "#e8f0fe" : undefined,
            }}
        >
            <div className={`min-w-0 ${disableTruncate ? "" : "truncate"} ${contentClassName}`}>{children}</div>
        </td>
    );
};